
export function checkStoreStatus() {
  const timeZone = 'Europe/London'; 
  const now = new Date();
  
  const dayParts = new Intl.DateTimeFormat('en-GB', { 
    timeZone, 
    hour: 'numeric', 
    minute: 'numeric', 
    hourCycle: 'h23'
  }).formatToParts(now);

  const dayOfWeekFormatter = new Intl.DateTimeFormat('en-GB', { 
    timeZone, 
    weekday: 'long' 
  }).format(now);

  // Convert weekday string to numeric mapping (0=Sun, 1=Mon, ..., 6=Sat)
  const daysMap = {
    'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3,
    'Thursday': 4, 'Friday': 5, 'Saturday': 6
  };
  const dayOfWeek = daysMap[dayOfWeekFormatter] ?? now.getDay();

  const currentHour = parseInt(dayParts.find(p => p.type === 'hour')?.value || '0', 10);
  const currentMinute = parseInt(dayParts.find(p => p.type === 'minute')?.value || '0', 10);
  
  const currentTime = currentHour + (currentMinute / 60);
  
  if (dayOfWeek === 6) {
    if (currentTime < 3.0) {
      // Midnight to 3:00 AM (Friday night)
      return { isEatInOpen: true, isTakeawayOpen: true };
    } else if (currentTime < 12.0) {
      // 3:00 AM to 12:00 PM
      return { isEatInOpen: false, isTakeawayOpen: false };
    } else {
      // 12:00 PM onwards
      return { isEatInOpen: true, isTakeawayOpen: true };
    }
  }

  // Open at 12:00 PM
  const OPENING_TIME = 12.00; 

  if (currentTime < OPENING_TIME) {
    return { isEatInOpen: false, isTakeawayOpen: false };
  }

  // Fridays stay open until manually closed
  if (dayOfWeek === 5) {
    return {
      isEatInOpen: true,
      isTakeawayOpen: true
    };
  }

  let eatInCloseTime = 22.0;     // 10:00 PM
  let takeawayCloseTime = 22.0;  // 10:00 PM

  if (dayOfWeek === 0 || (dayOfWeek >= 1 && dayOfWeek <= 4)) {
    // Sunday to Thursday
    eatInCloseTime = 21.5;      // 9:30 PM (eat-in orders stop)
    takeawayCloseTime = 21.75;  // 9:45 PM (store closes)
  }

  return {
    isEatInOpen: currentTime < eatInCloseTime,
    isTakeawayOpen: currentTime < takeawayCloseTime
  };
}
